<section class="admin-project-list">
  <div class="admin-project-list__toolbar">
    <h2>Manage projects</h2>
    <a mat-flat-button color="primary" routerLink="/admin/projects/new">Add project</a>
  </div>

  <ul class="admin-project-list__items">
    @for (project of projects$ | async; track project) {
      <li class="admin-project-list__item">
        <span class="admin-project-list__meta">
          <strong>{{ project.name }}</strong>
          <span> — {{ project.status }}</span>
        </span>
        <div class="admin-project-list__actions">
          <button mat-button color="primary" type="button" (click)="editProject(project.id)">Edit</button>
          <button mat-button color="warn" type="button" (click)="confirmDeleteProject(project)">Delete</button>
        </div>
      </li>
    }
  </ul>
</section>
